import { useRef, useEffect } from 'react';
import {
  isAndroid,
  getStateBarHeight,
  HRouter,
  isHarmonyOS,
} from '@haidilao-private/jsbridge';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { $vw } from '@/utils';
import { headerInitProps } from '@/helper/common/interface';
import { TOP_BAR_HEIGHT } from '@/helper/common/constant';
import './index.scss';
interface initProps {
  custom?: headerInitProps | null; //自定义参数
}
const HHeader = (props: initProps) => {
  const header = useSelector((state: RootState) => state.HeaderConfig);
  const { rightClick, rightContent, theme, title, isHeader, className } =
    props.custom || header;
  const hdlHeadelView = useRef<any>(null);
  const headerView = useRef<any>(null);

  useEffect(() => {
    if (isAndroid || isHarmonyOS) {
      if (localStorage.getItem(TOP_BAR_HEIGHT)) {
        return;
      }
      getStateBarHeight((res: any) => {
        let { stateBarHeight } = res;
        stateBarHeight = (stateBarHeight || 44) / window.devicePixelRatio;
        const height = $vw(stateBarHeight); //换算vw单位
        localStorage.setItem(TOP_BAR_HEIGHT, height);
      });
    }
  }, []);
  /**
   * @description: 返回上一页
   * @param {*}
   * @return {*}
   */
  const goBack = () => {
    HRouter.backWebView();
  };
  return (
    isHeader && (
      <div
        className={`h-header  ${className} ${theme}`}
        ref={hdlHeadelView}
        style={{
          paddingTop: String(localStorage.getItem(TOP_BAR_HEIGHT)),
        }}
      >
        <div className="header__content" ref={headerView}>
          {/* 左侧 */}
          <div className="header__back" onClick={goBack}></div>
          {/* 标题 */}
          <div className="header__title">{title}</div>
          {/* 右侧 */}
          {rightContent && (
            <div className="header__right" onClick={rightClick}>
              {rightContent}
            </div>
          )}
        </div>
      </div>
    )
  );
};

export default HHeader;
